import { render } from "./jtTopicCheck.vue?vue&type=template&id=9d7983c6&scoped=true"
import script from "./jtTopicCheck.vue?vue&type=script&lang=js"
export * from "./jtTopicCheck.vue?vue&type=script&lang=js"

import "./jtTopicCheck.vue?vue&type=style&index=0&id=9d7983c6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7983c6"]])

export default __exports__